import * as NUMBER from 'constant/number'
import { Modal } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'

const FormModal = ({ children, handleSubmit, loading, onCancel, title, visible, width = NUMBER.ONE_THOUSAND, readOnly }) => {
  return (
    <Modal
      bodyStyle={{
        backgroundColor: '#F7F7F7'
      }}
      cancelText={readOnly ? 'Close' : 'Cancel'}
      closable={false}
      confirmLoading={loading}
      destroyOnClose={true}
      maskClosable={false}
      okButtonProps={{ disabled: readOnly }}
      okText='Submit'
      onCancel={onCancel}
      onOk={handleSubmit}
      style={{ top: width && NUMBER.TWENTY }}
      title={title}
      visible={visible}
      width={width}
    >
      {children}
    </Modal>
  )
}

FormModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  readOnly: PropTypes.bool,
  title: PropTypes.string,
  visible: PropTypes.bool,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

export default FormModal
